import { render, staticRenderFns } from "./GeonamesItems.vue?vue&type=template&id=262d1a90&scoped=true&"
import script from "./GeonamesItems.vue?vue&type=script&lang=js&"
export * from "./GeonamesItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262d1a90",
  null
  
)

export default component.exports